(function(){
  var active = false;
  var embeds = [];
  var imgs = [];
  var modals = [];
  var videos = [];

  ready(function(){
    setLazyItems();
    if (embeds.length || imgs.length || videos.length) {
      lazyLoadAll();
    }
    // if there are more after the first images load, then bound listeners
    if (embeds.length || imgs.length || videos.length) {
      registerListener('resize', lazyLoadAll);
      registerListener('scroll', lazyLoadAll, null, true);
    }
    // if we have any modals on the page
    modals = [].slice.call(document.querySelectorAll('.modal-popup'));
    if (modals.length) {
      registerListener('modal:open', loadModal);
    }
  });

  function loadModal() {
    var modal;
    var toDelete = [];

    for (var i = 0; i < modals.length; i++){
      if (modals[i].style.display === 'block') {
        modal = modals[i];
        toDelete.push(i);
      }
    }

    setLazyItems(modal);
    lazyLoadAll();

    for (var i = 0; i < toDelete.length; i++){
      modals.splice(toDelete[i] - i, 1);
    }
    if (!modals.length) {
      removeListener('modal:open', lazyLoadAll);
    }
  }

  function forEach(array, fn){
    for (var i = 0; i < array.length; i++){
      fn(array[i]);
    }
  }

  function isInViewport(el, offset){
    offset = offset || 100;
    var rect = el.getBoundingClientRect();

    return (
      el.offsetParent !== null &&
      rect.bottom >= 0 &&
      rect.right >= 0 &&

      rect.top - offset <= (
        window.innerHeight ||
        document.documentElement.clientHeight) &&

      rect.left - offset <= (
        window.innerWidth ||
        document.documentElement.clientWidth)
     );
  }

  function isVisible(node) {
    return !!(node.offsetWidth || node.offsetHeight || node.getClientRects().length);
  }

  function lazyLoadAll(event) {
    if (active === false) {
      active = true;
      if (embeds.length) lazyLoadEmbeds();
      if (imgs.length) lazyLoadImages();
      if (videos.length) lazyLoadVideos();
      if (!embeds.length && !imgs.length && !videos.length) {
        removeListener('resize', lazyLoadAll);
        removeListener('scroll', lazyLoadAll, null, true);
      }
      active = false;
    }
  }

  function lazyLoadEmbeds() {
    var toDelete = [];

    for (var i = 0; i < embeds.length; i++){
      if (isInViewport(embeds[i].el, 500)) {
        loadEmbed(embeds[i].el, embeds[i].attr);
        toDelete.push(i);
      }
    }

    for (var i = 0; i < toDelete.length; i++){
      embeds.splice(toDelete[i] - i, 1);
    }
  }

  function lazyLoadImages() {
    var toDelete = [];

    for (var i = 0; i < imgs.length; i++){
      if (isInViewport(imgs[i].el)) {
        loadImage(imgs[i].el, imgs[i].attr);
        toDelete.push(i);
      }
    }

    for (var i = 0; i < toDelete.length; i++){
      imgs.splice(toDelete[i] - i, 1);
    }
  }

  function lazyLoadVideos() {
    var toDelete = [];

    for (var i = 0; i < videos.length; i++){
      if (isInViewport(videos[i].el)) {
        loadVideo(videos[i].el);
        toDelete.push(i);
      }
    }

    for (var i = 0; i < toDelete.length; i++){
      videos.splice(toDelete[i] - i, 1);
    }
  }

  var loadImgFns = {
    "data-async-bg": function(el, src){
      el.style.backgroundImage = 'url("' + src + '")';
    },
    "data-async-src": function(el, src){
      el.src = src;
    }
  }

  function loadEmbed(el) {
    var embed = document.createElement('div');
    embed.innerHTML = el.getAttribute('data-html').trim();

    // loop in reverse so that the condition remains true as we remove children
    // from embed
    for (var i=embed.children.length - 1; i > -1; i--) {
      var child = embed.children[i];
      if (!child) break;
      // if the element is an iframe we want to keep the loader in place until
      // the iframe is loaded
      if (child.tagName === 'IFRAME') {
        child.onload = function() {
          el.removeChild(el.children[0]);
        };
        el.appendChild(child);

      // if the element is a script we need to create it on the dom otherwise
      // it won't execute
      } else if (child.tagName === 'SCRIPT') {
        var script = document.createElement('script');
        script.innerHTML = child.innerHTML;
        script.async = child.async;
        if (child.src) script.src = child.src;
        if (child.type) script.type = child.type;
        el.appendChild(script);
      } else {
        var loader = el.querySelector('.embed-loader');
        loader.parentNode.removeChild(loader);
        el.appendChild(child);
      }
    }

    el.removeAttribute('data-html');
    el.classList.remove('lazy-embed');
  }

  function loadImage(el, srcAttrName, loadFunc) {
    if (!el.classList) return;  // loading images won't work on <IE10
    if (el.classList.contains('loaded')) return;

    var img = new Image(),
        src = el.getAttribute(srcAttrName);

    img.onload = function() {
      loadImgFns[srcAttrName](el, src);
      el.classList.add('loaded');
    }
    img.onerror = function() {
      el.classList.remove('img-loader');
      el.classList.add('load-error');
    }

    el.classList.add('img-loader');
    img.src = src;
    el.removeAttribute(srcAttrName);
  }

  function loadVideo(el) {
    if (el.getAttribute('data-async-poster')) {
      el.setAttribute('poster', el.getAttribute('data-async-poster'));
    }

    if (!el.classList) return;  // loading images won't work on <IE10
    if (el.classList.contains('loaded')) return;

    for (var i=0; i < el.children.length; i++) {
      var videoSource = el.children[i];
      if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
        videoSource.src = videoSource.getAttribute('data-async-src');
        videoSource.removeAttribute('data-async-src');
      }
    }

    el.load();
    el.classList.add('loaded');

    // Ugly timeout because it seems .load() takes some time, causing .paused to
    // be true immediately after .load() is called.
    setTimeout(function(){
      if (!el.canPlayType || el.paused) {
        el.setAttribute('poster', el.getAttribute('data-fallback-src'));
      }
    }, 50);
  }

  function ready(fn) {
    if (document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading"){
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function registerListener(event, func, container, capture) {
    container = container || window;
    if (container.addEventListener) {
      container.addEventListener(event, func, !!capture);
    } else {
      container.attachEvent('on' + event, func);
    }
  }

  function removeListener(event, func, container, capture) {
    container = container || window;
    container.removeEventListener(event, func, !!capture);
  }

  // we add all elements that are currently visible within the container
  function setLazyItems(container){
    container = container || document;
    forEach([].slice.call(container.querySelectorAll('[data-async-bg]')), function(el){
      if (isVisible(el))
        imgs.push({ attr: 'data-async-bg', el: el });
    });
    forEach([].slice.call(container.querySelectorAll('img[data-async-src]')), function(el){
      if (isVisible(el))
        imgs.push({ attr: 'data-async-src', el: el });
    });
    forEach([].slice.call(container.querySelectorAll('video.async-video')), function(el){
      if (isVisible(el))
        videos.push({ el: el });
    });
    forEach([].slice.call(container.querySelectorAll('.lazy-embed')), function(el){
      if (isVisible(el))
        embeds.push({ el: el });
    });
  }
})();
